import { z } from 'zod'

const AIRulesSchema = z.object({
  role: z.string(),
  rules: z.array(z.string()),
  knowledge: z.string(),
})

const EvaluationSchema = z.object({
  criteria: z.array(z.string()),
  expected_fix: z.string().optional(),
})

const KeySignalSchema = z.object({
  signal: z.string(),
  positive: z.string(),
  negative: z.string(),
})

const InterviewerGuideSchema = z.object({
  overview: z.string(),
  key_signals: z.array(KeySignalSchema).default([]),
  common_pitfalls: z.array(z.string()).default([]),
  debrief_questions: z.array(z.string()).default([]),
})

const PatchSchema = z.object({
  file: z.string(),
  find: z.string(),
  replace: z.string(),
})

const ScenarioTypeSchema = z.enum(['debug', 'feature', 'refactor']).default('debug')

export const ScenarioConfigSchema = z.object({
  name: z.string(),
  description: z.string(),
  type: ScenarioTypeSchema,
  difficulty: z.enum(['easy', 'medium', 'hard']),
  estimated_time: z.string(),
  tags: z.array(z.string()).default([]),
  repo: z.string(),
  commit: z.string(),
  setup: z.array(z.string()).default([]),
  patch: z.array(PatchSchema).default([]),
  delete_files: z.array(z.string()).default([]),
  briefing: z.string(),
  ai_rules: AIRulesSchema,
  solution: z.string().optional(),
  acceptance_criteria: z.array(z.string()).optional(),
  evaluation: EvaluationSchema.optional(),
  interviewer_guide: InterviewerGuideSchema.optional(),
  license: z.string().optional(),
})

export type ScenarioConfig = z.infer<typeof ScenarioConfigSchema>
export type ScenarioType = z.infer<typeof ScenarioTypeSchema>
export type AIRules = z.infer<typeof AIRulesSchema>
export type Evaluation = z.infer<typeof EvaluationSchema>
export type InterviewerGuide = z.infer<typeof InterviewerGuideSchema>
export type KeySignal = z.infer<typeof KeySignalSchema>

export interface ScenarioInfo {
  name: string
  config: ScenarioConfig
  builtIn: boolean
}
